import React from 'react';
import { ActivityFormCardBaseProps } from './SharedActivityFormComponents';
import { ActivityFormCardLayout } from './ActivityFormCardLayout';
import { FlexMd, FlexEnd } from 'components/Elements';
import { ErrorNotifierSlim } from 'components/notifiers/ErrorNotifierSlim';
import { ActivityType } from 'models/Activity';
import strings from 'strings/strings.json';
import Button from 'components/buttons/Button';

export function ActivityFormCard(props: ActivityFormCardBaseProps): JSX.Element {
    const { title, onSubmit, pageOne, pageTwo, error, submitting, activityType } = props;

    let buttonTitle = '';

    switch (activityType) {
        case ActivityType.PRESENTATION_SLIDE:
            buttonTitle = strings.activityForm.saveSlide;
            break;
        case ActivityType.QUESTIONNAIRE:
            buttonTitle = strings.activityForm.saveQuestionnaire;
            break;
        case ActivityType.TASK:
        default:
            buttonTitle = strings.activityForm.saveTask;
            break;
    }

    return (
        <ActivityFormCardLayout
            title={title}
            onSubmit={onSubmit}
            pageOne={pageOne}
            pageTwo={pageTwo}
            activityType={activityType}
            renderBottomSection={() => (
                <FlexEnd>
                    <FlexMd>
                        {error && <ErrorNotifierSlim description={error} />}
                        <Button title={buttonTitle} aria={buttonTitle} type="submit" submitting={submitting} />
                    </FlexMd>
                </FlexEnd>
            )}
        />
    );
}
